export const CRITEO_PARTNER_ID = "101219"; // WARNING
// Mettre à jour apps/booking/vite.config.ts si on change cette valeur
// (On ne peut pas importer ce fichier dans le vite.config.ts)

export const CRITEO_TAG_URL = `https://dynamic.criteo.com/js/ld/ld.js?a=${CRITEO_PARTNER_ID}`;
